import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import {PORTAL_URL} from '../../Constants';
import { useTranslation,Trans  } from 'react-i18next';

const Services = () => {
     const { t } = useTranslation();
    const [modalShow, setModalShow] = useState(false);
    const [modalContent, setModalContent] = useState({ title: '', description: '', imgSrc: '' });

    // JSON Array for services
    const services = [
        {
            title: t('servicesTitle1'),
            description: t('servicesDesc1'),
            imgSrc: '/images/home/services/1.jpg',
        },
        {
            title: t('servicesTitle2'),
            description: t('servicesDesc2'),
            imgSrc: '/images/home/services/2.jpg',
        },
        {
            title: t('servicesTitle3'),
            description: t('servicesDesc3'),
            imgSrc: '/images/home/services/3.jpg',
        },
    ];

    const handleExploreClick = (service) => {
        setModalContent(service); // Set modal content dynamically
        setModalShow(true); // Show the modal
    };

    return (
        <section className='lyt-section typ-service-section' id='swoffr'>
            <div className='container'>
                <div className='heading-wrapper'>
                    <div>
                        <h2 className='bs-heading typdblue mb-2' data-aos="fade-in" data-aos-delay="200">{t('servicesTitle')}</h2>
                        <p className='bs-para typgrey' data-aos="fade-in" data-aos-delay="300">{t('servicesDesc')}</p>
                    </div>
                    <Link
                        className="bs-btn"
                        to="/service"
                        aria-label="Navigate to Service Listing"
                        data-aos="fade-in"
                        data-aos-delay="200"
                    >
                        {t('viewAll')} <span className="icon icon-right-arrow"></span>
                    </Link>
                </div>

                <div className='bs-grid-box'>
                    {/* Dynamically Render Cards */}
                    {services.map((service, index) => (
                        <div className='bs-card typ-service' data-aos="fade-in" data-aos-delay={(index + 1) * 100} key={index}>
                            <div className='box-img'>
                                <img
                                    className="img-fluid"
                                    src={service.imgSrc}
                                    alt={service.title}
                                    width={384}
                                    height={297}
                                />
                            </div>
                            <div className='box-text'>
                                <div className='title'>{service.title}</div>
                                <div className='discription'>{service.description}</div>
                                <div className='text-end'>
                                    <button
                                        className="bs-btn typexplore"
                                        onClick={() => handleExploreClick(service)}
                                    >
                                        {t('exploreMore')} <span className="icon icon-right-arrow"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* React Bootstrap Modal */}
                    <Modal
                        show={modalShow}
                        onHide={() => setModalShow(false)}
                        centered // This centers the modal
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>{modalContent.title}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="text-center"
                            style={{ maxHeight: '60vh', overflowY: 'auto' }}
                            >
                            <img
                                src={modalContent.imgSrc}
                                alt={modalContent.title}
                                className="img-fluid mb-3"
                                style={{ maxHeight: '300px', objectFit: 'cover', width: '100%' }}
                            />
                            <p className='text-start bs-para typ-fw400 typ-16'>{modalContent.description}</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <a variant="secondary" className='bs-btn' href={PORTAL_URL}  >
                                                   {t('logIn')}
                                               </a>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        </section>
    );
};

export default Services;
